var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-13 15:33:18
 * @modify date 2021-09-13 15:33:18
 * @desc [微信认证]
 */
/// <reference path="wx.d.ts" />
import lodash from 'lodash';
import { BindAll, Debounce } from 'lodash-decorators';
import { action, computed, observable } from 'mobx';
import { Subject } from 'rxjs';
import { EnumAPI } from '../../apis';
import { EnumPlatforms, EnumWechatAuthorizeState } from '../../enums';
// import { BaseModel } from "../bases";
import { BaseModel } from '../../libraries';
import { AjaxBasics, Log } from './../../libraries';
let WechatController = class WechatController {
    constructor(appId) {
        this.appId = appId;
        /**
         * WeixinJSBridge 异步数据加载订阅
         * @type {Promise<any>}
         * @memberof ControllerUser
         */
        this.WeixinJSSubject = new Subject();
        this.Model = new BaseModel({ type: 'object', storageKey: 'wechat' });
        /** 初始化 */
        this.isReady = false;
        /** 加载 */
        this.loading = false;
        this.jsApiList = [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            // 'onMenuShareWeibo',
            // 'onMenuShareQZone',
            // 'startRecord',
            // 'stopRecord',
            // 'onVoiceRecordEnd',
            // 'playVoice',
            // 'pauseVoice',
            // 'stopVoice',
            // 'onVoicePlayEnd',
            // 'uploadVoice',
            // 'downloadVoice',
            'chooseImage',
            // 'previewImage',
            'uploadImage',
            // 'downloadImage',
            // 'translateVoice',
            // 'getNetworkType',
            // 'openLocation',
            // 'getLocation',
            // 'hideOptionMenu',
            // 'showOptionMenu',
            // 'hideMenuItems',
            'showMenuItems',
            // 'hideAllNonBaseMenuItem',
            // 'showAllNonBaseMenuItem',
            // 'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            // 'openProductSpecificView',
            // 'addCard',
            // 'chooseCard',
            // 'openCard'
            'authorize',
            'getSetting',
        ];
        this.openTagList = ['wx-open-launch-weapp', 'wx-open-subscribe'];
    }
    /** 微信openID */
    get openid() {
        return lodash.get(this.Model.value, 'openid');
    }
    // @computed
    // public get weappOpenid() {
    //   return lodash.get(this.Model.value, "openId");
    // }
    // @computed
    // public get weappUnionId() {
    //   return lodash.get(this.Model.value, "unionId");
    // }
    /** 关注公众号 */
    // @computed
    // public get subscribe() {
    //   return lodash.eq(lodash.get(this.Model.value, "subscribe"), 1);
    // }
    /** 小程序环境 */
    get miniprogram() {
        return lodash.get(this.Model.value, 'miniprogram', false);
    }
    /** 当前属于大联想小程序子页面 */
    get miniprogramChildren() {
        return lodash.eq(lodash.get(this.Model.value, 'platform'), EnumPlatforms.weapp);
    }
    get WeixinJSBridge() {
        if (wx) {
            return wx;
        }
        return undefined;
    }
    toReady(isReady) {
        this.isReady = isReady;
    }
    onComplete() {
        this.WeixinJSSubject.next(true);
        this.WeixinJSSubject.complete();
    }
    async onReady(signUrl) {
        if (this.loading) {
            return Log.warning(` Weixin 加载中`);
        }
        if (this.isReady) {
            return Log.warning(` Weixin 已经加载`);
        }
        this.loading = true;
        const config = await AjaxBasics.request({
            ...EnumAPI.wechat_jsapi_sign,
            body: { signUrl },
            headers: { 'x-app-id': this.appId },
        });
        try {
            if (this.WeixinJSBridge.miniProgram) {
                this.WeixinJSBridge.miniProgram.getEnv((res) => {
                    console.log('LENG ~ WechatController ~ miniProgram ~ getEnv', res);
                    this.Model.merge(res);
                });
            }
            const res = await new Promise((res, rej) => {
                Log.info(` Weixin onReady`, config);
                this.WeixinJSBridge.ready(() => {
                    console.log('LENG ~ WechatController ~ this.WeixinJSBridge.ready ~ ready');
                    res(config);
                });
                this.WeixinJSBridge.error((error) => {
                    console.log('LENG ~ WechatController ~ this.WeixinJSBridge.error ~ error', error);
                    rej(error);
                });
                this.WeixinJSBridge.config({
                    jsApiList: this.jsApiList,
                    openTagList: this.openTagList,
                    appId: config.appId,
                    nonceStr: config.nonceStr,
                    signature: config.signature,
                    timestamp: config.timestamp,
                });
            });
            this.toReady(true);
            this.loading = false;
            console.log('LENG ~ WechatController ~ miniProgram ~ getEnv');
            this.WeixinJSSubject.next(true);
            this.WeixinJSSubject.complete();
            return res;
        }
        catch (error) {
            console.log('error:微信签名失败', error);
            this.loading = false;
            this.WeixinJSSubject.error(error);
            this.WeixinJSSubject.complete();
            throw error;
        }
    }
    /**
     * 获取“分享给朋友”及“分享到QQ”按钮点击状态及自定义分享内容接口（新）
     */
    updateAppMessageShareData(params) {
        Log.info('【 updateAppMessageShareData 】', params);
        this.WeixinJSSubject.toPromise().then(() => this.WeixinJSBridge.updateAppMessageShareData(params));
        return params;
    }
    /**
     * 获取“分享到朋友圈”及“分享到QQ空间”按钮点击状态及自定义分享内容接口（新）
     */
    updateTimelineShareData(params) {
        Log.info('【 updateTimelineShareData 】', params);
        this.WeixinJSSubject.toPromise().then(() => this.WeixinJSBridge.updateTimelineShareData(params));
        return params;
    }
    /**
     * 调起微信扫一扫接口
     */
    scanQRCode(params) {
        Log.info('【 scanQRCode 】', params);
        this.WeixinJSSubject.toPromise().then(() => this.WeixinJSBridge.scanQRCode(params));
        return params;
    }
    /**
     * 获取微信小程序 appid
     * @param jsCode
     */
    async onWeappSession(jsCode, appId) {
        const res = await AjaxBasics.request({
            ...EnumAPI.wechat_weapp_session,
            body: { jsCode },
            headers: { 'x-app-id': appId },
        });
        this.Model.merge(res);
        return res;
    }
    async onAuth(authCode) {
        const res = await AjaxBasics.request({
            ...EnumAPI.wechat_login,
            body: { authCode },
            headers: { 'x-app-id': this.appId },
        });
        const info = await AjaxBasics.request({
            ...EnumAPI.wechat_info,
            body: { openId: lodash.get(res, 'openid') },
            headers: { 'x-app-id': this.appId },
        });
        this.Model.merge(lodash.assign(res, info));
        return res;
    }
    async onSend() {
        return AjaxBasics.request({
            ...EnumAPI.wechat_send,
            body: {
                templateId: 'eYV50ZNOMZIajfYW7lSsdPOrL9XXMxOpkJ_FGOJ-u2Y',
                openId: this.openid,
                params: {
                    thing11: '商机状态通知',
                    phrase2: '测试状态',
                },
            },
            headers: { 'x-app-id': this.appId },
        });
    }
    /**
     * 授权 url https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_webpage_authorization.html#0
     * @param redirect_uri
     */
    getAuthorizeUrl(redirect_uri, scope = 'snsapi_userinfo', state = EnumWechatAuthorizeState.login) {
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=${encodeURIComponent(redirect_uri)}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
        Log.success('AuthorizeUrl', url);
        return url;
    }
};
__decorate([
    computed
], WechatController.prototype, "openid", null);
__decorate([
    computed
], WechatController.prototype, "miniprogram", null);
__decorate([
    computed
], WechatController.prototype, "miniprogramChildren", null);
__decorate([
    observable
], WechatController.prototype, "isReady", void 0);
__decorate([
    Debounce(999),
    action
], WechatController.prototype, "toReady", null);
WechatController = __decorate([
    BindAll()
], WechatController);
export { WechatController };
